
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FileText, Mail, Phone, Clock } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

export const PressResourcesSection = () => {
  const { language } = useLanguage();
  
  return (
    <section id="resources-section" className="py-12 px-4 bg-muted/30">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-6">
          🗂️ {language === 'fr' ? 'Ressources presse' : 'Press resources'}
        </h2>
        
        <div className="prose prose-lg dark:prose-invert max-w-none mb-8">
          <p>
            {language === 'fr' ? (
              "Recut structure une nouvelle relation entre créateurs, ayants droit et publics, en légalisant et valorisant les usages créatifs autour des œuvres."
            ) : (
              "Recut structures a new relationship between creators, rights holders and audiences, by legalizing and enhancing creative uses around works."
            )}
          </p>
          <p>
            {language === 'fr' ? (
              "Ce projet mêle culture numérique, droit, économie de la création, et narration native."
            ) : (
              "This project combines digital culture, law, creative economy, and native storytelling."
            )}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="outline"
                  size="lg"
                  className="flex gap-2 h-auto py-6 border-primary/20 hover:bg-primary/5 group relative"
                  disabled={true}
                >
                  <Clock className="h-5 w-5 text-muted-foreground animate-pulse" />
                  <span className="text-muted-foreground">
                    {language === 'fr' ? 'Télécharger le communiqué de presse (.pdf)' : 'Download press release (.pdf)'}
                  </span>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-background/80 rounded-lg">
                    <span className="text-sm font-medium">
                      {language === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
                    </span>
                  </div>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                {language === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="outline"
                  size="lg"
                  className="flex gap-2 h-auto py-6 border-primary/20 hover:bg-primary/5 group relative"
                  disabled={true}
                >
                  <Clock className="h-5 w-5 text-muted-foreground animate-pulse" />
                  <span className="text-muted-foreground">
                    {language === 'fr' ? 'Télécharger le dossier de presse (.pdf)' : 'Download press kit (.pdf)'}
                  </span>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-background/80 rounded-lg">
                    <span className="text-sm font-medium">
                      {language === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
                    </span>
                  </div>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                {language === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        
        <Card className="mb-8 border-border/40 bg-card/60 backdrop-blur-sm">
          <CardContent className="p-6">
            <h3 className="text-xl font-medium mb-4">
              {language === 'fr' ? '📬 Contact presse :' : '📬 Press contact:'}
            </h3>
            <div className="space-y-3">
              <p className="font-medium">Tangui Friant</p>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Mail className="h-4 w-4" />
                <a href="mailto:tangui@recut.art" className="hover:text-primary transition-colors">
                  tangui@recut.art
                </a>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Phone className="h-4 w-4" />
                <a href="tel:+33672717225" className="hover:text-primary transition-colors">
                  06 72 71 72 25
                </a>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
